import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AboutBannerImg1 from '../assets/images/about-banner-2.png';
import AboutBannerImg2 from '../assets/images/about-banner-3.png';
import { ASSETS_URL } from '../api/constants';

const AboutBox = ({ section3, section4 }) => {
  const section3Image = section3?.image ? `${ASSETS_URL}/${section3.image}` : AboutBannerImg1;
  const section4Image = section4?.image ? `${ASSETS_URL}/${section4.image}` : AboutBannerImg2;
  const section3Paragraphs = section3?.description
    ? section3.description.split(/\r?\n\r?\n/).filter(Boolean)
    : [
        'Jambobay is incredibly personal — and for most people, it’s the biggest transaction they’ll ever make.',
        'Jambobay is built on a deep understanding of movers’ needs and a motivation to help you accomplish your moving goals. Whether you start by requesting to connect with an agent or learn about your financing options, Jambobay works to understand your unique situation in order to connect you with a local real estate professional who can tailor their services to you, help you explore options, and be your advocate to win your next home.',
        'That’s also why Jambobay provides a suite of products and services that supercharge real estate professionals. We help agents across the country do business more efficiently so they can spend more time on what matters: helping movers get home. With digital workflows, client and performance insights, and smart communication tools, Jambobay shows up for our real estate agent partners so they can better show up for our shared customers.',
      ];
  const section4Paragraphs = section4?.description
    ? section4.description.split(/\r?\n\r?\n/).filter(Boolean)
    : [
        'Buying and selling real estate is a difficult process to navigate, because it is fragmented and complex. Your journey from your current home to your new home includes many steps — research, shop, tour, finance, appraise, inspect, negotiate an offer, close and move — all with no central navigator.',
        'Jambobay, the housing super app, solves these real pain points by providing seamless solutions integrated within the same ecosystem. With new functionality and features continuously improving the app and site, as well as connections to great agent partners and expert loan officers at Jambobay Home Loans, Jambobay offers a better experience for renters, buyers and sellers.',
      ];

   return (
    <section className="about-banner-section">
        <Row>
           <Col lg={6} md={12}>
            <div className="about-image">
              <img 
                src={section3Image}
                alt={section3?.title || 'Modern House'} 
                className="house-img"
              />
            </div>
          </Col>
          <Col lg={6} md={12} className='about-content-box align-self-center'>
            <div className="about-content">
              <h1 className="about-title">
                {section3?.title ? section3.title : <><span>Jambobay</span> is here for you,</>}
              </h1>
               <p className="about-subtitle pb-40">{section3?.sub_description || 'Every step of the way'}</p>
              {section3Paragraphs.map((paragraph, index) => (
                <p className="about-description" key={index}>
                  {paragraph}
                </p>
              ))}
            </div>
          </Col>
           <Col lg={6} md={12} className='about-content-box align-self-center order-2 order-lg-0'>
            <div className="about-content">
              <h1 className="about-title">
                {section4?.title ? section4.title : <>Modernizing the real estate <span className='text-black'>experience</span></>}
              </h1>
              {section4Paragraphs.map((paragraph, index) => (
                <p className="about-description" key={index}>
                  {paragraph}
                </p>
              ))}
            </div>
          </Col>
          <Col lg={6} md={12} className="order-1 order-lg-0">
            <div className="about-image">
              <img 
                src={section4Image}
                alt={section4?.title || 'Modern House'} 
                className="house-img"
              />
            </div>
          </Col>         
        </Row>
    </section>
  );
}

export default AboutBox;